import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#F4364C", // Pink-red for main buttons and CTAs
      light: "#FF6B6B",
      dark: "#C53030",
    },
    secondary: {
      main: "#FFB800", // Yellow/orange from the design
      light: "#FFD700",
      dark: "#FF8C00",
    },
    info: {
      main: "#3182CE", // Blue for statistics and info
      light: "#63B3ED",
      dark: "#2C5282",
    },
    success: {
      main: "#38A169", // Green for success states
    },
    warning: {
      main: "#D69E2E", // Orange for warnings
    },
    background: {
      default: "#FFFFFF",
      paper: "#F7FAFC",
    },
    text: {
      primary: "#1A202C",
      secondary: "#4A5568",
    },
  },
  typography: {
    fontFamily: '"Lexend", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: "2rem",
    },
    h2: {
      fontWeight: 600,
      fontSize: "2rem",
    },
    h6: {
      fontWeight: 600,
    },
    button: {
      fontWeight: 600,
      textTransform: "none",
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "none",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          border: "2px solid #222",
          fontWeight: 600,
          borderRadius: "80px",

          "&.MuiButton-sizeLarge": {
            padding: "8px 12px",
            fontSize: "0.875rem",

            "@media (min-width: 960px)": {
              padding: "12px 32px",
              fontSize: "1.5rem",
              borderRadius: "16px",
            },
          },
          "&:hover": {
            boxShadow: "none",
          },

          "&.Mui-disabled": {
            borderColor: "transparent",
          },
        },

        contained: {},
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF",
          color: "#1A202C",
          boxShadow: "none",
        },
      },
    },
  },
});

export default theme;
